import { Button } from '@/components/ui/button';
import {
  LaunchConfig,
  launchConfigService,
} from '@/services/launch-config.service';
import { useQuery } from '@tanstack/react-query';
import { Plus, Upload } from 'lucide-react';

interface LoansListHeaderProps {
  onCreateNew: () => void;
  onUploadPortfolio: () => void;
}

export const LoansListHeader = ({
  onCreateNew,
  onUploadPortfolio,
}: LoansListHeaderProps) => {
  const { data } = useQuery<LaunchConfig>({
    queryKey: ['launch-config', 'current'],
    queryFn: () => launchConfigService.getCurrentConfig(),
  });

  return (
    <div className="mb-8" data-test-id="loans-list-header">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div data-test-id="header-title-section">
          {data?.client && (
            <h1
              className="text-2xl font-bold mb-2"
              data-test-id="page-title"
            >
              {data.client}
            </h1>
          )}
          {(data?.portfolio_fund || data?.sub_portfolio) && (
            <p className="section-subtitle" data-test-id="section-header">
              {data?.portfolio_fund && data?.sub_portfolio
                ? `${data.portfolio_fund} / ${data.sub_portfolio}`
                : data?.portfolio_fund || data?.sub_portfolio || ''}
            </p>
          )}
        </div>
        <div className="flex gap-3" data-test-id="header-actions">
          <Button
            variant="outline"
            onClick={onUploadPortfolio}
            className="flex items-center gap-2"
            data-test-id="upload-portfolio-button"
          >
            <Upload className="h-4 w-4" data-test-id="upload-portfolio-icon" />
            Upload Portfolio
          </Button>
          <Button
            onClick={onCreateNew}
            className="flex items-center gap-2"
            data-test-id="create-loan-button"
          >
            <Plus className="h-4 w-4" data-test-id="create-loan-icon" />
            Add New Loan
          </Button>
        </div>
      </div>
    </div>
  );
};
